module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 tw-flex tw-flex-col"
  }, [_c('div', {
    staticClass: "head mb-2 "
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "inp-button blue",
    attrs: {
      "type": "button",
      "title": "Rafraichir la liste",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-sync-alt mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Rafraichir la liste")])]), _vm._v(" "), (_vm.selectedYear) ? [_c('div', {
    staticClass: "inp-input-mini icon ml-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getPrimoboxExercices]
    }
  }, _vm._l((_vm.listYears), function(year) {
    return _c('option', [_vm._v(_vm._s(year))])
  })), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "body-table"
  }, [(_vm.dataReady) ? _c('table', {
    staticClass: "generic-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "line"
  }, [_c('th', {
    staticClass: "section cln-periode"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-nbr"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-envoi"
  }), _vm._v(" "), _c('dthiv', {
    staticClass: "section cln-etat"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-action"
  })], 1), _vm._v(" "), _vm._l((_vm.primoboxExercices), function(exercice) {
    return _c('tr', [_c('th', {
      staticClass: "td cln-periode"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-start"
    }, [_vm._v(_vm._s(_vm.formatMoisAnnee(exercice.MoisExercice, exercice.AnneeExercice)))])]), _vm._v(" "), _c('th', {
      staticClass: "td cln-debut text-center"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(exercice.DateDebutExercice, "DD/MM/YY")))])]), _vm._v(" "), _c('th', {
      staticClass: "td cln-fin text-center"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(exercice.DateFinExercice, "DD/MM/YY")))])]), _vm._v(" "), _c('th', {
      staticClass: "td cln-nbr text-center"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(exercice.NombreBulletins))])]), _vm._v(" "), _c('th', {
      staticClass: "td cln-envoi text-center"
    }, [(exercice.PossedeRedistribution) ? _c('i', {
      staticClass: "fa-solid fa-circle-info tw-text-blue-600 tw-pr-1"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(exercice.DateDistribution, "DD/MM/YY - HH:mm:ss")))])]), _vm._v(" "), _c('th', {
      staticClass: "td cln-etat text-center"
    }, [(_vm.canShowSimpleEtat(exercice.EtatEnum)) ? _c('div', [_c('span', [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.canShowAnomalieEtat(exercice.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-red-700 fas fa-exclamation-triangle"
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-red-700 tw-underline",
      on: {
        "click": function($event) {
          _vm.messageAnomalie()
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.canShowValiderEtat(exercice.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-orange-600 fas fa-exclamation-circle "
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-orange-600 tw-underline",
      on: {
        "click": function($event) {
          _vm.validerDistribution(exercice)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('th', {
      staticClass: "cln-actions"
    }, [(_vm.canShowButtonDistribuer(exercice.EtatEnum)) ? _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5 tw-w-32",
      attrs: {
        "icon": "fa-solid fa-download",
        "color": "blue",
        "outline": true,
        "disabled": !_vm.canDistribute(exercice),
        "title": 'Distribuer les bulletins dans l\'espace sécurisé des salariés',
        "text": 'Distribuer'
      },
      on: {
        "click": function($event) {
          _vm.openModalDistribuer(exercice)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.canShowButtonDistribuer(exercice.EtatEnum)) ? _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5 tw-w-32",
      attrs: {
        "icon": "fa-solid fa-eye",
        "color": "blue",
        "outline": true,
        "disabled": !exercice.ExisteTraitementDetails,
        "title": 'Voir le détail des bulletins distribuer',
        "text": 'Voir le détail'
      },
      on: {
        "click": function($event) {
          _vm.openModalDistribuer(exercice)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5",
      attrs: {
        "icon": "fa-solid fa-sync-alt",
        "color": "green",
        "outline": true,
        "disabled": !_vm.canDistribute(exercice),
        "title": 'Synchronise les salariés avec Primobox',
        "text": 'Synchroniser'
      },
      on: {
        "click": function($event) {
          _vm.synchroniser([])
        }
      }
    })], 1)])
  })], 2)]) : _c('div', [_c('loader')], 1)]), _vm._v(" "), _c('ModalDetailsEnvoiBulletinComponent', {
    ref: "modalDetailsEnvoiBulletinComponent",
    on: {
      "SynchroniserAndDistribuer": _vm.synchroniserAndDistribuer,
      "SynchroniserAndRedistribuer": _vm.synchroniserAndRedistribuer,
      "validerRedistribution": _vm.validerRedistribution
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cln-periode",
    attrs: {
      "title": "Période de paie"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("PÉRIODE DE PAIE")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-debut",
    attrs: {
      "title": "Date de début de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DÉBUT")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-fin",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-nbr",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NOMBRE DE BULLETINS")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-envoi",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE/HEURE DE L'ENVOI")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-etat",
    attrs: {
      "title": "État de l'envoi'"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ÉTAT DE L'ENVOI")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-action",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ACTIONS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6d18cce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Primobox/envoiBulletins/envoiBulletins.vue.html
// module id = sW2/
// module chunks = 2